<template>
  <v-dialog
    v-model="dialog"
    max-width="380"
    persistent
  >
    <v-card class="pa-3">
      <v-layout class="justify-center align-center">
        <v-flex xs7>
          <v-img
            :src="confirmationImage"
            :lazy-src="confirmationImage"
            contain
          />
        </v-flex>
      </v-layout>
      <v-card-title class="px-1 mx-1">
        <span class="subheading confirmation-text">{{ $t('message.bizgainOnboarding.restartConfirmation') }}<span class="font-weight-medium ml-1">{{ businessName }} </span></span>
      </v-card-title>

      <v-card-actions>
        <v-layout justify-center>
          <v-flex class="shrink">
            <v-btn
              color="primary"
              :class="{'px-3':$vuetify.breakpoint.xsOnly, 'px-4':!$vuetify.breakpoint.xsOnly}"
              @click="onContinue"
            >
              {{ $t('message.bizgainOnboarding.cancel') }}
            </v-btn>
          </v-flex>
          <v-flex class="shrink ml-3 pl-1">
            <v-btn
              outline
              color="primary"
              :class="{'px-2':$vuetify.breakpoint.xsOnly, 'px-3':!$vuetify.breakpoint.xsOnly}"
              @click="onStartOver"
            >
              {{ $t('message.bizgainOnboarding.startOver') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VDialog,
  VCard,
  VCardActions,
  VCardTitle,
  VBtn,
  VImg,
  VLayout,
  VFlex
} from 'vuetify/lib';
import { mapActions, mapGetters } from 'vuex';
import {  bizgainOnboardingRoutes, bizgainOnboardingImage } from 'Features/bizgainOnboarding/constants';
import { updateBusinessDetailsFromDbSession } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { Chat } from 'Mixins/chat';

export default {
  mixins: [Chat],
  components: {
    VDialog,
    VCard,
    VCardActions,
    VCardTitle,
    VBtn,
    VImg,
    VLayout,
    VFlex
  },
  data() {
    return {
      dialog: true,
      bizgainOnboardingRoutes,
      confirmationImage: bizgainOnboardingImage.confirmation
    };
  },
  async created(){
    let bizgainOnboardingLocalStorage = JSON.parse(localStorage.getItem('bizgain-onboarding'));
    let sessionId = bizgainOnboardingLocalStorage && bizgainOnboardingLocalStorage.bizgainOnboarding && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data.sessionId;
    if(sessionId){
      await updateBusinessDetailsFromDbSession(sessionId);
    }
  },
  computed: {
    ...mapGetters([
      'businessDetails',
      'disableChatSupport',
      'freshChatRestoreId',
      'freshChatExternalId',
      'businessName',
      'isAutoGeneratedFlow'
    ]),
    businessName(){
      return this.businessDetails && this.businessDetails.name;
    }
  },
  methods: {
    ...mapActions(['resetPersistedState', 'updateBusinessDetails']),
    onStartOver(){
      this.dialog = false;
      this.destroyChatPanel();
      if(!this.disableChatSupport){
        this.initializeChat(this.freshChatRestoreId, this.freshChatExternalId, this.$vuetify.theme, this.businessProfileId, this.businessName, this.user, this.$vuetify.breakpoint.xsOnly);
      }
      localStorage.removeItem('lastVisitedRoute');
      this.resetPersistedState();

      // Adding Global site redirection her to enforce new web extraction based flow.
      window.location.href = 'https://bizgain.com';

      if (this.isAutoGeneratedFlow){
        this.$router.push({
          name: this.bizgainOnboardingRoutes.SetupBusinessInfo.name,
          params: { isAppFlow: true },
          query: { agentid: this.$route.query.agentid }
        });
      }
      else{
        this.$router.push({
          name: this.bizgainOnboardingRoutes.ExtractBusinessDetails.name,
          params: { isAppFlow: true },
          query: { agentid: this.$route.query.agentid }
        });
      }
    },
    onContinue(){
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmation-text{
  text-align: center;
}
</style>